import { axios, Response } from '../index'
import { Folder } from './get-folder-files-and-subfolders'

const updateFolderGroupVisibility = (
  groupId: string,
  folderId: string,
  name: string,
  folderVisibility: 'PUBLIC' | 'PRIVATE',
  parentFolderId: string
): Response<Folder> => {
  return axios.put(`/v1/group/${groupId}/folders/${folderId}`, {
    id: groupId,
    name: name,
    folderVisibility: folderVisibility,
    parentFolderId: parentFolderId
  })
}

export default updateFolderGroupVisibility
